import { Component, Input } from "@angular/core";

@Component({
    selector: "app-unread-badge",
    templateUrl: "./unread-badge.component.html",
    styleUrls: ["./unread-badge.component.scss"]
})
export class UnreadBadgeComponent {
    @Input() count: number = 0;
    @Input() variant: "count" | "dot" = "dot";
    @Input() top?: string;
    @Input() right?: string;
    @Input() bottom?: string;
    @Input() left?: string;
    @Input() static: boolean = false;

    get showBadge(): boolean {
        return this.count > 0;
    }
}
